<template>
  <div class="page-NominacionCreate hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Nominaciones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/Admin">Hidrocarburos</router-link>
                  </li>
                  <li class="breadcrumb-item active">Nominaciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-body">
                <div class="row justify-content-center">
                  <div class="form-group col-md-2">
                    <label>Fecha inicial</label>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      :class="
                        $v.form.fecha_inicial.$invalid
                          ? 'is-invalid'
                          : 'is-valid'
                      "
                      v-model="form.fecha_inicial"
                      @input="validaFechas"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Fecha final</label>
                    <input
                      type="date"
                      class="form-control form-control-sm"
                      :class="
                        $v.form.fecha_final.$invalid ? 'is-invalid' : 'is-valid'
                      "
                      v-model="form.fecha_final"
                      @input="validaFechas"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Nombre</label>
                    <input
                      type="text"
                      v-model="form.nombre"
                      class="form-control form-control-sm"
                      :class="
                        $v.form.nombre.$invalid ? 'is-invalid' : 'is-valid'
                      "
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <label>Planeaciones</label>
                    <v-select
                      class="form-control form-control-sm p-0"
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="form.planeacion_id"
                      label="nombre"
                      :options="listasForm.plneaciones"
                      :filterable="true"
                      :reduce="(p) => p.id"
                    >
                    </v-select>
                  </div>
                  <div class="col-md-3">
                    <label>Calificación</label>
                    <v-select
                      class="form-control form-control-sm p-0"
                      :class="[
                        $store.getters.getDarkMode ? 'dark-vselect' : '',
                        $v.form.calificacion_id.$invalid
                          ? 'is-invalid'
                          : 'is-valid',
                      ]"
                      v-model="form.calificacion_id"
                      label="nombre"
                      :options="listasForm.calificaciones"
                      :filterable="true"
                      :reduce="(c) => c.id"
                    >
                    </v-select>
                  </div>
                  <div class="col-md-3">
                    <label>Tipos Productos</label>
                    <v-select
                      class="form-control form-control-sm p-0"
                      :class="[
                        $store.getters.getDarkMode ? 'dark-vselect' : '',
                        $v.form.tipo_producto.$invalid
                          ? 'is-invalid'
                          : 'is-valid',
                      ]"
                      v-model="form.tipo_producto"
                      label="descripcion"
                      :options="listasForm.tipos_productos"
                      :filterable="true"
                      :reduce="(tp) => tp.numeracion"
                    >
                    </v-select>
                  </div>
                  <div class="col-md-6">
                    <label>Observación</label>
                    <textarea
                      v-model="form.observacion"
                      class="form-control form-control-sm"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <router-link to="/Hidrocarburos/Nominaciones">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="newItem = true"
                      v-if="
                        $store.getters.can('hidrocarburos.nominaciones.index')
                      "
                    >
                      <i class="fas fa-reply"></i><br />Volver
                    </button>
                  </router-link>
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-if="
                      !$v.form.$invalid &&
                        ($store.getters.can(
                          'hidrocarburos.nominaciones.create'
                        ) ||
                          $store.getters.can('hidrocarburos.nominaciones.edit'))
                    "
                    @click="saveNominacion"
                  >
                    <i class="fas fa-paper-plane"></i><br />Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import Loading from "../../../../components/Loading";
import axios from "axios";
import vSelect from "vue-select";

export default {
  name: "NominacionCreate",

  components: {
    Loading,
    vSelect,
  },

  data() {
    return {
      cargando: false,
      modal: {
        title: "",
        accion: "",
      },
      planeacionesOption: [],
      tipos_productoOption: [],
      listasForm: {
        plneaciones: [],
        calificaciones: [],
        tipos_productos: [],
      },
      calificacionesOption: [],
      form: {
        fecha_inicial: null,
        fecha_final: null,
        nombre: null,
        planeacion_id: null,
        calificacion_id: null,
        tipo_producto: null,
        estado: 1,
        observacion: null,
        dias_nomi: 0,

        //   fecha_inicial: this.fecha_inicial,
        //   fecha_final: this.fecha_final,
        //   nombre: this.nombre,
        //   observacion: this.observacion,
        //   estado: this.estado,
        //   planeacion_id: this.planeacion.id,
        //   tipo_producto: this.tipo_producto,
        //   dias_nomi: this.dias_nomi,
      },
    };
  },

  validations: {
    form: {
      fecha_inicial: {
        required,
        minValue: (value) => value > new Date().toISOString(),
      },
      fecha_final: {
        required,
        minValue: (value) => value > new Date().toISOString(),
      },
      nombre: {
        required,
      },
      calificacion_id: {
        required,
      },
      tipo_producto: {
        required,
      },
      estado: {
        required,
      },
    },
  },

  computed: {
    ...mapState("modOperacion", ["listas"]),
    ...mapState("modHidrocarburos", ["loading", "empresas"]),
  },

  methods: {
    ...mapActions("modOperacion", ["actGetListas"]),
    ...mapActions("modHidrocarburos", [
      "actSaveNominacion",
    ]),

    getPlaneaciones() {
      axios.get("api/hidrocarburos/planeaciones/list").then((response) => {
        this.listasForm.plneaciones = response.data;
      });
    },
    getCalificaciones() {
      axios.get("api/hidrocarburos/calificaciones/lista").then((response) => {
        this.listasForm.calificaciones = response.data;
      });
    },
    getTiposProducto() {
      axios.get("/api/lista/83").then((response) => {
        this.listasForm.tipos_productos = response.data;
      });
    },
    validaFechas() {
      if (this.form.fecha_inicial && this.form.fecha_final) {
        let fecha_menor = new Date(this.form.fecha_inicial);
        let fecha_mayor = new Date(this.form.fecha_final);

        // Se valida que la fecha inicial sea menor que la fecha final
        if (fecha_menor > fecha_mayor) {
          this.form.fecha_final = null;
          this.$swal({
            icon: "error",
            title: `La fecha inicio no puede ser mayor a la fecha fin..`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          return false;
        }
        this.calculoNomi();
      }
      if (this.form.fecha_inicial && this.$v.form.fecha_inicial.$invalid) {
        console.log(`Entro en if2`);
        this.form.fecha_inicial = null;
        this.$swal({
          icon: "error",
          title: `La fecha inicio no puede ser menor o igual a hoy.`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return false;
      }
    },
    calculoNomi() {
      let fechaMenor = new Date(this.form.fecha_inicial).getTime();
      let fechaMayor = new Date(this.form.fecha_final).getTime();
      var diff = fechaMayor - fechaMenor;
      this.form.dias_nomi = diff / (1000 * 60 * 60 * 24);
    },
    saveNominacion() {
      if (!this.$v.form.$invalid) {
        this.cargando = true;
        this.actSaveNominacion(this.form)
          .then((response) => {
            this.cargando = false;
            if (response.id) {
              this.$router.push({
                path: "/Hidrocarburos/NominacionesEdit/" + response.id,
              });
              this.$swal({
                icon: "success",
                title: "La nominación base se creó con exito",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            } else {
              this.$swal({
                icon: "error",
                title: "No se pudo crear la nominación.",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            }
          })
          .catch(function(e) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },
  },

  beforeMount() {
    this.actGetListas(28);
    this.getTiposProducto();
    this.getPlaneaciones();
    this.getCalificaciones();
  },
};
</script>
